import React from "react";

type PropsType = {
  data: any;
};

export const ConfrontationDetail = ({ data }: PropsType) => {
  return (
    <div className="d-flex flex-column gap-2">
      <div className="details__container">
        <div className="details__content">
          <span className="details__title">Identifiant : </span>
          <span className="details__value">
            {data?.operationLoad?.uniqueIdentifier}{" "}
          </span>
        </div>
        <div className="details__content">
          <span className="details__title">Type : </span>
          <span className="details__value">
            {data?.operationLoad?.loadType?.name}
          </span>
        </div>
        <div className="details__content">
          <span className="details__title">Status : </span>
          <span className="details__value">{data?.state?.name}</span>
        </div>
        <div className="details__content">
          <span className="details__title">Type de confrontation : </span>
          <span className="details__value">{data?.type?.name}</span>
        </div>
        <div className="details__content">
          <span className="details__title">Signalé par : </span>
          <span className="details__value">{data?.signaledBy?.fullname}</span>
        </div>
        <div className="details__content">
          <span className="details__title">Date de signalement : </span>
          <span className="details__value">
            {data?.createdAt ?? "_"}
          </span>
        </div>
        <div className="details__content">
          <span className="details__title">Traité par : </span>
          <span className="details__value">
            {data?.processedBy?.fullname ?? "-"}
          </span>
        </div>
        <div className="details__content">
          <span className="details__title">Date de traitement : </span>
          <span className="details__value">
            {data?.processedAt ?? "-"}
          </span>
        </div>
      </div>
      <div className="details__container">
        <span className="details__title">Commentaire : </span>
        <span className="details__value">
            {data?.comment ?? "-"}
          </span>
      </div>
    </div>
  );
};
